module.exports = __webpack_public_path__ + "1b4cd7badb0fe14c9d6f6a96d2b9ee9a.svg";